import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/word.png'
import _imports_1 from '@/assets/images/adobe.png'


const _hoisted_1 = { class: "models" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Ajuda", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "header" }
const _hoisted_6 = {
  class: "search",
  for: "search-document-subject"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"filters\"><button class=\"tooltip\"><figure><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 11V17L11 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9 17L7 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10H18C15 10 14 9 14 6V2L22 10Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure></button></div>", 1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", null, "Documento word", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", null, "Documento PDF", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Imagem do tipo de arquivo do documento."
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Imagem do tipo de arquivo do documento."
}, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "actions"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "none",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.9992 1.68018C12.1902 1.68018 12.3733 1.75603 12.5083 1.89106C12.6434 2.02609 12.7192 2.20922 12.7192 2.40018V13.4626L16.2904 9.89138C16.3563 9.82064 16.4358 9.7639 16.5241 9.72455C16.6125 9.68519 16.7078 9.66403 16.8045 9.66233C16.9012 9.66062 16.9972 9.67841 17.0868 9.71462C17.1765 9.75083 17.2579 9.80473 17.3263 9.8731C17.3947 9.94147 17.4486 10.0229 17.4848 10.1126C17.521 10.2022 17.5388 10.2982 17.5371 10.3949C17.5354 10.4916 17.5142 10.5869 17.4749 10.6753C17.4355 10.7636 17.3788 10.8431 17.308 10.909L12.508 15.709C12.373 15.8438 12.19 15.9195 11.9992 15.9195C11.8084 15.9195 11.6254 15.8438 11.4904 15.709L6.69042 10.909C6.61968 10.8431 6.56294 10.7636 6.52359 10.6753C6.48424 10.5869 6.46308 10.4916 6.46137 10.3949C6.45967 10.2982 6.47745 10.2022 6.51366 10.1126C6.54988 10.0229 6.60378 9.94147 6.67215 9.8731C6.74052 9.80473 6.82196 9.75083 6.91161 9.71462C7.00126 9.67841 7.09729 9.66062 7.19396 9.66233C7.29064 9.66403 7.38598 9.68519 7.4743 9.72455C7.56262 9.7639 7.64211 9.82064 7.70802 9.89138L11.2792 13.4626V2.40018C11.2792 2.20922 11.3551 2.02609 11.4901 1.89106C11.6251 1.75603 11.8083 1.68018 11.9992 1.68018ZM3.99922 16.0002C4.2114 16.0002 4.41488 16.0845 4.56491 16.2345C4.71494 16.3845 4.79922 16.588 4.79922 16.8002V19.2002C4.79922 20.0866 5.51282 20.8002 6.39282 20.8002H17.6008C17.8109 20.8002 18.0188 20.7588 18.2129 20.6784C18.4069 20.5979 18.5832 20.48 18.7316 20.3314C18.8801 20.1829 18.9978 20.0065 19.078 19.8123C19.1582 19.6182 19.1994 19.4102 19.1992 19.2002V16.8002C19.1992 16.588 19.2835 16.3845 19.4335 16.2345C19.5836 16.0845 19.787 16.0002 19.9992 16.0002C20.2114 16.0002 20.4149 16.0845 20.5649 16.2345C20.7149 16.3845 20.7992 16.588 20.7992 16.8002V19.2002C20.7992 20.0486 20.4623 20.8623 19.8625 21.4624C19.2628 22.0624 18.4492 22.3998 17.6008 22.4002H6.39282C5.97295 22.4 5.55724 22.317 5.16945 22.156C4.78167 21.9951 4.42941 21.7593 4.13281 21.4621C3.83622 21.1649 3.6011 20.8121 3.44091 20.424C3.28072 20.0359 3.19859 19.62 3.19922 19.2002V16.8002C3.19922 16.588 3.28351 16.3845 3.43354 16.2345C3.58357 16.0845 3.78705 16.0002 3.99922 16.0002Z"
    })
  ])
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M11.9998 20.2702C15.5298 20.2702 18.8198 18.1902 21.1098 14.5902C22.0098 13.1802 22.0098 10.8102 21.1098 9.40021C18.8198 5.80021 15.5298 3.72021 11.9998 3.72021C8.46984 3.72021 5.17984 5.80021 2.88984 9.40021C1.98984 10.8102 1.98984 13.1802 2.88984 14.5902C5.17984 18.1902 8.46984 20.2702 11.9998 20.2702Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "actions word"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "baixar"),
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "none",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.9992 1.68018C12.1902 1.68018 12.3733 1.75603 12.5083 1.89106C12.6434 2.02609 12.7192 2.20922 12.7192 2.40018V13.4626L16.2904 9.89138C16.3563 9.82064 16.4358 9.7639 16.5241 9.72455C16.6125 9.68519 16.7078 9.66403 16.8045 9.66233C16.9012 9.66062 16.9972 9.67841 17.0868 9.71462C17.1765 9.75083 17.2579 9.80473 17.3263 9.8731C17.3947 9.94147 17.4486 10.0229 17.4848 10.1126C17.521 10.2022 17.5388 10.2982 17.5371 10.3949C17.5354 10.4916 17.5142 10.5869 17.4749 10.6753C17.4355 10.7636 17.3788 10.8431 17.308 10.909L12.508 15.709C12.373 15.8438 12.19 15.9195 11.9992 15.9195C11.8084 15.9195 11.6254 15.8438 11.4904 15.709L6.69042 10.909C6.61968 10.8431 6.56294 10.7636 6.52359 10.6753C6.48424 10.5869 6.46308 10.4916 6.46137 10.3949C6.45967 10.2982 6.47745 10.2022 6.51366 10.1126C6.54988 10.0229 6.60378 9.94147 6.67215 9.8731C6.74052 9.80473 6.82196 9.75083 6.91161 9.71462C7.00126 9.67841 7.09729 9.66062 7.19396 9.66233C7.29064 9.66403 7.38598 9.68519 7.4743 9.72455C7.56262 9.7639 7.64211 9.82064 7.70802 9.89138L11.2792 13.4626V2.40018C11.2792 2.20922 11.3551 2.02609 11.4901 1.89106C11.6251 1.75603 11.8083 1.68018 11.9992 1.68018ZM3.99922 16.0002C4.2114 16.0002 4.41488 16.0845 4.56491 16.2345C4.71494 16.3845 4.79922 16.588 4.79922 16.8002V19.2002C4.79922 20.0866 5.51282 20.8002 6.39282 20.8002H17.6008C17.8109 20.8002 18.0188 20.7588 18.2129 20.6784C18.4069 20.5979 18.5832 20.48 18.7316 20.3314C18.8801 20.1829 18.9978 20.0065 19.078 19.8123C19.1582 19.6182 19.1994 19.4102 19.1992 19.2002V16.8002C19.1992 16.588 19.2835 16.3845 19.4335 16.2345C19.5836 16.0845 19.787 16.0002 19.9992 16.0002C20.2114 16.0002 20.4149 16.0845 20.5649 16.2345C20.7149 16.3845 20.7992 16.588 20.7992 16.8002V19.2002C20.7992 20.0486 20.4623 20.8623 19.8625 21.4624C19.2628 22.0624 18.4492 22.3998 17.6008 22.4002H6.39282C5.97295 22.4 5.55724 22.317 5.16945 22.156C4.78167 21.9951 4.42941 21.7593 4.13281 21.4621C3.83622 21.1649 3.6011 20.8121 3.44091 20.424C3.28072 20.0359 3.19859 19.62 3.19922 19.2002V16.8002C3.19922 16.588 3.28351 16.3845 3.43354 16.2345C3.58357 16.0845 3.78705 16.0002 3.99922 16.0002Z"
    })
  ])
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "card" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h1", null, "Documento word", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h1", null, "Documento PDF", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Imagem do tipo de arquivo do documento."
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Imagem do tipo de arquivo do documento."
}, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "actions"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "none",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.9992 1.68018C12.1902 1.68018 12.3733 1.75603 12.5083 1.89106C12.6434 2.02609 12.7192 2.20922 12.7192 2.40018V13.4626L16.2904 9.89138C16.3563 9.82064 16.4358 9.7639 16.5241 9.72455C16.6125 9.68519 16.7078 9.66403 16.8045 9.66233C16.9012 9.66062 16.9972 9.67841 17.0868 9.71462C17.1765 9.75083 17.2579 9.80473 17.3263 9.8731C17.3947 9.94147 17.4486 10.0229 17.4848 10.1126C17.521 10.2022 17.5388 10.2982 17.5371 10.3949C17.5354 10.4916 17.5142 10.5869 17.4749 10.6753C17.4355 10.7636 17.3788 10.8431 17.308 10.909L12.508 15.709C12.373 15.8438 12.19 15.9195 11.9992 15.9195C11.8084 15.9195 11.6254 15.8438 11.4904 15.709L6.69042 10.909C6.61968 10.8431 6.56294 10.7636 6.52359 10.6753C6.48424 10.5869 6.46308 10.4916 6.46137 10.3949C6.45967 10.2982 6.47745 10.2022 6.51366 10.1126C6.54988 10.0229 6.60378 9.94147 6.67215 9.8731C6.74052 9.80473 6.82196 9.75083 6.91161 9.71462C7.00126 9.67841 7.09729 9.66062 7.19396 9.66233C7.29064 9.66403 7.38598 9.68519 7.4743 9.72455C7.56262 9.7639 7.64211 9.82064 7.70802 9.89138L11.2792 13.4626V2.40018C11.2792 2.20922 11.3551 2.02609 11.4901 1.89106C11.6251 1.75603 11.8083 1.68018 11.9992 1.68018ZM3.99922 16.0002C4.2114 16.0002 4.41488 16.0845 4.56491 16.2345C4.71494 16.3845 4.79922 16.588 4.79922 16.8002V19.2002C4.79922 20.0866 5.51282 20.8002 6.39282 20.8002H17.6008C17.8109 20.8002 18.0188 20.7588 18.2129 20.6784C18.4069 20.5979 18.5832 20.48 18.7316 20.3314C18.8801 20.1829 18.9978 20.0065 19.078 19.8123C19.1582 19.6182 19.1994 19.4102 19.1992 19.2002V16.8002C19.1992 16.588 19.2835 16.3845 19.4335 16.2345C19.5836 16.0845 19.787 16.0002 19.9992 16.0002C20.2114 16.0002 20.4149 16.0845 20.5649 16.2345C20.7149 16.3845 20.7992 16.588 20.7992 16.8002V19.2002C20.7992 20.0486 20.4623 20.8623 19.8625 21.4624C19.2628 22.0624 18.4492 22.3998 17.6008 22.4002H6.39282C5.97295 22.4 5.55724 22.317 5.16945 22.156C4.78167 21.9951 4.42941 21.7593 4.13281 21.4621C3.83622 21.1649 3.6011 20.8121 3.44091 20.424C3.28072 20.0359 3.19859 19.62 3.19922 19.2002V16.8002C3.19922 16.588 3.28351 16.3845 3.43354 16.2345C3.58357 16.0845 3.78705 16.0002 3.99922 16.0002Z"
    })
  ])
], -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M11.9998 20.2702C15.5298 20.2702 18.8198 18.1902 21.1098 14.5902C22.0098 13.1802 22.0098 10.8102 21.1098 9.40021C18.8198 5.80021 15.5298 3.72021 11.9998 3.72021C8.46984 3.72021 5.17984 5.80021 2.88984 9.40021C1.98984 10.8102 1.98984 13.1802 2.88984 14.5902C5.17984 18.1902 8.46984 20.2702 11.9998 20.2702Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 1,
  class: "actions word"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "baixar"),
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "none",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.9992 1.68018C12.1902 1.68018 12.3733 1.75603 12.5083 1.89106C12.6434 2.02609 12.7192 2.20922 12.7192 2.40018V13.4626L16.2904 9.89138C16.3563 9.82064 16.4358 9.7639 16.5241 9.72455C16.6125 9.68519 16.7078 9.66403 16.8045 9.66233C16.9012 9.66062 16.9972 9.67841 17.0868 9.71462C17.1765 9.75083 17.2579 9.80473 17.3263 9.8731C17.3947 9.94147 17.4486 10.0229 17.4848 10.1126C17.521 10.2022 17.5388 10.2982 17.5371 10.3949C17.5354 10.4916 17.5142 10.5869 17.4749 10.6753C17.4355 10.7636 17.3788 10.8431 17.308 10.909L12.508 15.709C12.373 15.8438 12.19 15.9195 11.9992 15.9195C11.8084 15.9195 11.6254 15.8438 11.4904 15.709L6.69042 10.909C6.61968 10.8431 6.56294 10.7636 6.52359 10.6753C6.48424 10.5869 6.46308 10.4916 6.46137 10.3949C6.45967 10.2982 6.47745 10.2022 6.51366 10.1126C6.54988 10.0229 6.60378 9.94147 6.67215 9.8731C6.74052 9.80473 6.82196 9.75083 6.91161 9.71462C7.00126 9.67841 7.09729 9.66062 7.19396 9.66233C7.29064 9.66403 7.38598 9.68519 7.4743 9.72455C7.56262 9.7639 7.64211 9.82064 7.70802 9.89138L11.2792 13.4626V2.40018C11.2792 2.20922 11.3551 2.02609 11.4901 1.89106C11.6251 1.75603 11.8083 1.68018 11.9992 1.68018ZM3.99922 16.0002C4.2114 16.0002 4.41488 16.0845 4.56491 16.2345C4.71494 16.3845 4.79922 16.588 4.79922 16.8002V19.2002C4.79922 20.0866 5.51282 20.8002 6.39282 20.8002H17.6008C17.8109 20.8002 18.0188 20.7588 18.2129 20.6784C18.4069 20.5979 18.5832 20.48 18.7316 20.3314C18.8801 20.1829 18.9978 20.0065 19.078 19.8123C19.1582 19.6182 19.1994 19.4102 19.1992 19.2002V16.8002C19.1992 16.588 19.2835 16.3845 19.4335 16.2345C19.5836 16.0845 19.787 16.0002 19.9992 16.0002C20.2114 16.0002 20.4149 16.0845 20.5649 16.2345C20.7149 16.3845 20.7992 16.588 20.7992 16.8002V19.2002C20.7992 20.0486 20.4623 20.8623 19.8625 21.4624C19.2628 22.0624 18.4492 22.3998 17.6008 22.4002H6.39282C5.97295 22.4 5.55724 22.317 5.16945 22.156C4.78167 21.9951 4.42941 21.7593 4.13281 21.4621C3.83622 21.1649 3.6011 20.8121 3.44091 20.424C3.28072 20.0359 3.19859 19.62 3.19922 19.2002V16.8002C3.19922 16.588 3.28351 16.3845 3.43354 16.2345C3.58357 16.0845 3.78705 16.0002 3.99922 16.0002Z"
    })
  ])
], -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 1,
  class: "no-models"
}
const _hoisted_46 = {
  key: 2,
  class: "no-options full"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "173",
  height: "173",
  viewBox: "0 0 173 173",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.4",
    d: "M116.702 14.4166H56.2964C30.0581 14.4166 14.416 30.0587 14.416 56.297V116.631C14.416 142.941 30.0581 158.583 56.2964 158.583H116.63C142.869 158.583 158.511 142.941 158.511 116.703V56.297C158.583 30.0587 142.941 14.4166 116.702 14.4166Z",
    fill: "#292D32"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M113.531 70.2812H59.4688C56.5133 70.2812 54.0625 67.8304 54.0625 64.875C54.0625 61.9196 56.5133 59.4688 59.4688 59.4688H113.531C116.487 59.4688 118.938 61.9196 118.938 64.875C118.938 67.8304 116.487 70.2812 113.531 70.2812Z",
    fill: "#292D32"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M113.531 113.531H59.4688C56.5133 113.531 54.0625 111.08 54.0625 108.125C54.0625 105.17 56.5133 102.719 59.4688 102.719H113.531C116.487 102.719 118.938 105.17 118.938 108.125C118.938 111.08 116.487 113.531 113.531 113.531Z",
    fill: "#292D32"
  })
], -1)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<figure><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 11V17L11 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9 17L7 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10H18C15 10 14 9 14 6V2L22 10Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("button", null, [
  /*#__PURE__*/_createElementVNode("figure", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M7 7L17 17M7 17L17 7",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ])
  ])
], -1)
const _hoisted_53 = { key: 0 }
const _hoisted_54 = ["src"]

import { useAxios } from '@/api/axios'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import MyModal from '@/components/modal/MyModal.vue'
import ModelTypeEnum from '@/enums/ModelTypeEnum'
import ModelInterface, { ModelFileInterface } from '@/models/ModelInterface'
import { AxiosResponse } from 'axios'
import { computed, onMounted, ref, watch } from 'vue'
import ModelFileMimeTypeEnum from '@/enums/ModelFileMimeTypeEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpView',
  setup(__props) {

const search = ref(new RegExp('.*.*', 'i'))
const axios = useAxios()
const models = ref<ModelInterface[]>()
const documentModels = computed(() => (models.value ?? []).filter((model) => model.type == ModelTypeEnum.DOCUMENT_MODEL && search.value.test(model.name)))
const documentFlowModels = computed(() => (models.value ?? []).filter((model) => model.type == ModelTypeEnum.FLOW_MODEL && search.value.test(model.name)))
const isModelModalOpen = ref(false)
const selectedModel = ref<ModelInterface>()
const selectedFilesSrc = ref<string[]>([])
const isMobileOptionsFilterOpen = ref<boolean>(false)

const tab = ref<string>('models')

const toggleTab = (type: string) => {
  tab.value = type;
};

const toggleOverflow = () => {
  isMobileOptionsFilterOpen.value = !isMobileOptionsFilterOpen.value
  document.body.style.overflow = isMobileOptionsFilterOpen.value ? 'hidden' : 'auto'
}

async function loadSelectedModelFiles () {
  if (selectedModel.value?.files) {
    const sources = await Promise.all(
      selectedModel.value.files.map(async (file) => {
        return await visualizeFile(file as ModelFileInterface)
      })
    )
    selectedFilesSrc.value = sources
  }
}

async function visualizeFile (file: ModelFileInterface): Promise<string> {
  try {
    const response = await axios.get(`/api/models/get-file-content/${file.id}`, { responseType: 'blob' })
    return URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
  } catch (error) {
    console.error('Erro ao buscar o documento:', error)
    return ''
  }
}

watch(selectedModel, async () => {
  await loadSelectedModelFiles()
}, { deep: true, immediate: true })

function getModels () {
  axios.get('/api/models')
    .then((res: AxiosResponse<ModelInterface[]>) => {
      models.value = res.data
    })
}

function downloadFiles (files: ModelFileInterface[]): void {
  files.forEach((file) => {
    axios.get(`/api/models/get-file-content/${file.id}`, { responseType: 'blob' })
      .then(response => {
        const url = URL.createObjectURL(new Blob([response.data]))

        const link = window.document.createElement('a')
        link.href = url
        link.setAttribute('download', file.name)
        link.style.display = 'none'
        window.document.body.appendChild(link)
        link.click()
        window.document.body.removeChild(link)
      })
      .catch(error => {
        console.error('Erro ao buscar o documento:', error)
      })
  })
}

onMounted(() => {
  getModels()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin/home'))),
      class: "back"
    }, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        _createElementVNode("input", {
          autocomplete: "off",
          type: "text",
          placeholder: "Digite sua busca",
          id: "search-document-subject",
          name: "search-document-subject",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (search.value = new RegExp(`.*${($event.target as HTMLInputElement).value}.*`, 'i')), ["enter"]))
        }, null, 32),
        _hoisted_7
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['tab', tab.value])
    }, [
      _createElementVNode("h1", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleTab('models')))
      }, "Modelos"),
      _createElementVNode("h1", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleTab('flow')))
      }, "Fluxos"),
      _hoisted_9
    ], 2),
    (!(models.value && !documentModels.value.length && Array.isArray(models.value) && !documentFlowModels.value.length) && tab.value == 'models')
      ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
          (documentModels.value.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["itens", {lower: documentModels.value.length < 4}])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentModels.value, (model) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["item", model.file_mime_type])
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15,
                      (model.file_mime_type !== _unref(ModelFileMimeTypeEnum).WORD)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("button", {
                              class: "tooltip",
                              onClick: ($event: any) => (downloadFiles(model.files as ModelFileInterface[]))
                            }, _hoisted_19, 8, _hoisted_17),
                            _createElementVNode("button", {
                              class: "tooltip",
                              onClick: ($event: any) => {selectedModel.value = model; isModelModalOpen.value = true}
                            }, _hoisted_22, 8, _hoisted_20)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (downloadFiles(model.files as ModelFileInterface[]))
                            }, _hoisted_26, 8, _hoisted_24)
                          ]))
                    ]),
                    _createElementVNode("h2", null, _toDisplayString(model.name), 1)
                  ], 2))
                }), 256))
              ], 2))
            : (models.value && !documentModels.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27))
              : (_openBlock(), _createBlock(SpinnerLoader, { key: 2 }))
        ]))
      : _createCommentVNode("", true),
    (!(models.value && !documentModels.value.length && Array.isArray(models.value) && !documentFlowModels.value.length) && tab.value == 'flow')
      ? (_openBlock(), _createElementBlock("section", _hoisted_28, [
          (documentFlowModels.value.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["itens", {lower: documentFlowModels.value.length < 4}])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentFlowModels.value, (model) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["item", model.file_mime_type])
                  }, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      (model.file_mime_type !== _unref(ModelFileMimeTypeEnum).WORD)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("button", {
                              class: "tooltip",
                              onClick: ($event: any) => (downloadFiles(model.files as ModelFileInterface[]))
                            }, _hoisted_37, 8, _hoisted_35),
                            _createElementVNode("button", {
                              class: "tooltip",
                              onClick: ($event: any) => {selectedModel.value = model; isModelModalOpen.value = true}
                            }, _hoisted_40, 8, _hoisted_38)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (downloadFiles(model.files as ModelFileInterface[]))
                            }, _hoisted_44, 8, _hoisted_42)
                          ]))
                    ]),
                    _createElementVNode("h2", null, _toDisplayString(model.name), 1)
                  ], 2))
                }), 256))
              ], 2))
            : (Array.isArray(models.value) && !documentFlowModels.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45))
              : (_openBlock(), _createBlock(SpinnerLoader, { key: 2 }))
        ]))
      : _createCommentVNode("", true),
    ((tab.value == 'models' && models.value && !documentModels.value.length) || (tab.value == 'flow' && models.value && !documentFlowModels.value.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _hoisted_47,
          (tab.value == 'models')
            ? (_openBlock(), _createElementBlock("h1", _hoisted_48, "Sem modelos por aqui."))
            : (_openBlock(), _createElementBlock("h1", _hoisted_49, "Sem fluxos por aqui."))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("nav", {
      class: _normalizeClass([{active: isMobileOptionsFilterOpen.value}, "action-filters"]),
      onClick: toggleOverflow
    }, [
      _createElementVNode("button", {
        onClick: [
          _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
          _cache[5] || (_cache[5] = ($event: any) => (toggleOverflow()))
        ]
      }, _hoisted_51),
      _hoisted_52
    ], 2),
    (selectedModel.value)
      ? (_openBlock(), _createBlock(MyModal, {
          key: 3,
          isOpen: isModelModalOpen.value,
          class: _normalizeClass('docView'),
          toggleModal: (v) => isModelModalOpen.value = v,
          width: '80rem',
          height: '50rem',
          zIndex: 10
        }, {
          default: _withCtx(() => [
            (selectedFilesSrc.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFilesSrc.value, (src) => {
                    return (_openBlock(), _createElementBlock("iframe", {
                      src: src,
                      width: "100%",
                      height: "100%"
                    }, null, 8, _hoisted_54))
                  }), 256))
                ]))
              : (selectedModel.value.files.length)
                ? (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
                : _createCommentVNode("", true),
            _createElementVNode("p", null, _toDisplayString(selectedModel.value?.description), 1)
          ]),
          _: 1
        }, 8, ["isOpen", "toggleModal"]))
      : _createCommentVNode("", true)
  ]))
}
}

})